import React from 'react';
import tickBlanco from '../../img/tickBlanco.svg';
import './styles.css';
import CircleLineStart from './CircleLineStart';
import CircleLineMiddle from './CircleLineMiddle';
import CircleLineEnd from './CircleLineEnd';
import { useNavigate } from 'react-router-dom';

const BloqueCard = ({
  bloqueCompleto,
  bloqueIndex,
  titulo,
  ejercicios,
  selectedDay,
}) => {
  const ejerciciosOrdenados = React.useMemo(() => {
    const toNumInf = (v) => {
      const n = Number(v);
      return Number.isFinite(n) ? n : Number.POSITIVE_INFINITY;
    };

    return [...(ejercicios || [])].sort((leftItem, rightItem) => {
      const leftHasSubgroup = leftItem.subgrupo != null;
      const rightHasSubgroup = rightItem.subgrupo != null;

      if (leftHasSubgroup !== rightHasSubgroup) return leftHasSubgroup ? -1 : 1;

      const leftGroup = String(leftItem.subgrupo ?? '');
      const rightGroup = String(rightItem.subgrupo ?? '');
      if (leftGroup !== rightGroup) return leftGroup.localeCompare(rightGroup);

      const leftGroupOrder = toNumInf(leftItem.subgrupo_orden);
      const rightGroupOrder = toNumInf(rightItem.subgrupo_orden);
      if (leftGroupOrder !== rightGroupOrder)
        return leftGroupOrder - rightGroupOrder;

      const leftOrder = toNumInf(leftItem.orden);
      const rightOrder = toNumInf(rightItem.orden);
      if (leftOrder !== rightOrder) return leftOrder - rightOrder;

      return String(leftItem.nombre ?? '').localeCompare(
        String(rightItem.nombre ?? '')
      );
    });
  }, [ejercicios]);

  const subgroupsCount = ejerciciosOrdenados.reduce((acc, ejercicio) => {
    if (ejercicio.subgrupo) {
      acc[ejercicio.subgrupo] = (acc[ejercicio.subgrupo] || 0) + 1;
    }
    return acc;
  }, {});

  const navigate = useNavigate();

  const bloque_numero = 'Bloque ' + bloqueIndex;

  const handleExerciseClick = (bloque) => {
    navigate(`/entrenamiento/bloque/`, { state: bloque });
  };

  return (
    <div className="entrenamiento-bloque-card">
      <div className="entrenamiento-header">
        <div className="entrenamiento-text-wrapper-subtitle">
          {bloque_numero}
        </div>
        <div className="entrenamiento-text-wrapper">{titulo}</div>
      </div>
      <div className="entrenamiento-content">
        {ejerciciosOrdenados.map((ejercicio, index) => {
          const stableKey =
            ejercicio.id_ejerciciobloque ??
            ejercicio.id_bloque_ejercicio ??
            ejercicio.id ??
            ejercicio.id_ejercicio;

          const isCompleted = ejercicio.completado;
          const hasSubgroup = ejercicio.subgrupo;

          const isSingleSubgroup =
            hasSubgroup && subgroupsCount[ejercicio.subgrupo] === 1;

          if (isSingleSubgroup) {
            return (
              <div
                key={stableKey}
                className="entrenamiento-exercise-item"
                role="button"
                tabIndex={0}
                aria-label={`ejercicio-${ejercicio.nombre}`}
                onClick={() =>
                  handleExerciseClick({
                    bloque_numero,
                    bloqueCompleto,
                    selectedDay,
                  })
                }
              >
                <div className="entrenamiento-icon-container">
                  <div
                    className={`entrenamiento-ellipse ${isCompleted ? 'complete' : ''}`}
                  >
                    {isCompleted ? (
                      <img
                        src={tickBlanco}
                        alt="Completed"
                        className="entrenamiento-tick-icon"
                      />
                    ) : (
                      <span className="entrenamiento-ellipse-text">
                        {ejercicio.subgrupo}
                        {ejercicio.subgrupo_orden}
                      </span>
                    )}
                  </div>
                </div>
                <div className="head-exercise">
                  <div className="entrenamiento-exercise-title">
                    {ejercicio.nombre}
                  </div>
                  <div className="entrenamiento-exercise-detail">
                    {ejercicio.resumenSeries}
                  </div>
                </div>
              </div>
            );
          }

          const isFirst =
            index === 0 ||
            ejercicio.subgrupo !== ejerciciosOrdenados[index - 1]?.subgrupo;
          const isLast =
            index === ejerciciosOrdenados.length - 1 ||
            ejercicio.subgrupo !== ejerciciosOrdenados[index + 1]?.subgrupo;
          const isMiddle = !isFirst && !isLast;

          let IconComponent;
          if (hasSubgroup) {
            if (isFirst) IconComponent = CircleLineStart;
            else if (isMiddle) IconComponent = CircleLineMiddle;
            else if (isLast) IconComponent = CircleLineEnd;
          }

          const positionClass = hasSubgroup
            ? isFirst
              ? 'first'
              : isMiddle
                ? 'middle'
                : isLast
                  ? 'last'
                  : ''
            : '';

          return (
            <div
              key={stableKey}
              className="entrenamiento-exercise-item"
              role="button"
              tabIndex={0}
              aria-label={`ejercicio-${ejercicio.nombre}`}
              onClick={() =>
                handleExerciseClick({
                  bloque_numero,
                  bloqueCompleto,
                  selectedDay,
                })
              }
            >
              <div className={`entrenamiento-icon-container ${positionClass}`}>
                {hasSubgroup && IconComponent ? (
                  <IconComponent
                    fill={isCompleted ? '#458898' : '#2d2d2d'}
                    subgroup={ejercicio.subgrupo}
                    order={ejercicio.subgrupo_orden}
                    isCompleted={isCompleted}
                  />
                ) : (
                  <div
                    className={`entrenamiento-ellipse ${isCompleted ? 'complete' : ''}`}
                  >
                    {isCompleted ? (
                      <img
                        src={tickBlanco}
                        alt="Completed"
                        className="entrenamiento-tick-icon"
                      />
                    ) : (
                      <span className="entrenamiento-ellipse-text">
                        {ejercicio.subgrupo}
                        {ejercicio.subgrupo_orden}
                      </span>
                    )}
                  </div>
                )}
              </div>
              <div className="head-exercise">
                <div className="entrenamiento-exercise-title">
                  {ejercicio.nombre}
                </div>
                <div className="entrenamiento-exercise-detail">
                  {ejercicio.resumenSeries}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BloqueCard;
